import { Component, OnInit } from '@angular/core';
import { LicenseService } from 'app/services/license.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html'
})
export class AppFooterComponent implements OnInit {
  errorMsg: string;
  licsenseServicesVersion: string;
  versions: any;

  constructor(private service: LicenseService) { 
      
    }

  ngOnInit(): void {
    console.log("Getting versions...");
    this.service.GetVersions()
      .subscribe(u => {
          this.versions = u;
          console.log(u);
          this.licsenseServicesVersion = u.LicenseServices;
      }, error => this.errorMsg = <any>error);
  }
  
 }



// WEBPACK FOOTER //
// ./src/app/components/app-footer/app-footer.component.ts